<div class="journey-block-ui">
    <div class="max-width-container xl:px-[100px] md:px-[6.9%] side-padding h-full relative">
        <div class="relative h-full">
            <div id="journeyContainer" [class]="journeyDetails.uiClass">
                <app-journey-tips-popup
                    *ngIf="isJourneyDetailsReady"
                    [currentStep]="currentStep"
                    [title]="journeyDetails.title"
                    [description]="journeyDetails.description"
                    [arrowPosition]="journeyDetails.arrowPosition"
                    [isFirstStep]="isFirstStep"
                    [isLastStep]="isLastStep"
                    [journeyArrayList]="journeyArrayList"
                    (skipJourney)="closeNextJourneyUi()"
                    (prevJourney)="onPrevJourney()"
                    (nextJourney)="onNextJourney()"></app-journey-tips-popup>
            </div>
        </div>
    </div>

    <div
        class="absolute bottom-[1.875rem] z-40 transition-all w-full"
        [ngClass]="{ 'opacity-0': journeyDetails.journey !== JourneyListOrder.ResumeLearning }">
        <app-progress-indicator [isFirstTimeJourney]="true"></app-progress-indicator>
    </div>
</div>
